import React from "react";
import SwanLogo from "../SwanLogo";
import { ChevronDownIcon } from "lucide-react";
const SwanGetFitted = ({ data, loading, handleShowDetails }) => {
  return (
    <div id="swan-btn-parent-div" style={{ cursor: "pointer" }}>
      {loading ? (
        <div>&nbsp;</div>
      ) : (
        <>
          <div
            id="result"
            onClick={handleShowDetails}
            className="w-full flex items-center cursor-pointer justify-between py-3 px-4 bg-white text-gray-900 border border-gray-200 rounded-xl font-medium hover:bg-gray-50 transition-colors"
          >
            <picture className="relative h-12 w-10 rounded-md overflow-hidden flex-shrink-0 flex items-center justify-center">
              <SwanLogo />
            </picture>
            <aside className="w-[calc(100%-50px)] pl-3 pr-2">
              <h4 className="text-[16px] font-medium">{data}</h4>
              <p className="text-[14px] text-gray-500">with Swan</p>
            </aside>

            <div className="opacity-[0.4]">
              <ChevronDownIcon className="w-[20px]" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SwanGetFitted;
